import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Moment from 'moment'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import EditIcon from '@material-ui/icons/Edit'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import TableToolbar from '../../../common/table-toolbar'
import Styles from '../../../common/styles'
import * as pageTextActions from '../../../store/page-texts'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'

const mapStateToProps = state => ({
  pageTexts: state.pageTexts
})

const mapDispatchToProps = dispatch => ({
  pageTextActions: bindActionCreators(pageTextActions, dispatch)
})

class PageTextsTable extends Component {
  componentDidMount () {
    this.props.pageTextActions.getPageTexts()
  }

  componentWillUnmount () {
    this.props.pageTextActions.clearPageTexts()
  }

  handleLanguageFilterChange = event => {
    const value = event.target.value

    this.props.pageTextActions.setFilter('country', value)
  }

  filterTexts = texts => {
    const countryFilter = texts.filter.country

    if (!countryFilter) return texts

    const items = texts.items.filter(u => u.country === countryFilter)
    const itemCount = items.length

    return { ...texts, items, itemCount }
  }

  confirmDialog = (message, proceed, abort, item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <h1>{Y`Confirm`}</h1>
            <p>{message}</p>
            <p>{Y`Do you want to proceed`}</p>
            <br/>
            <div className={this.props.classes.reactConfirmButtonGroup}>
              <button 
                className={this.props.classes.reactConfirmButtonGroupBtnNeutral}
                onClick={() => {
                  if(item)
                    abort(item)
                  else
                    abort()
                  onClose()
                }}>{Y`Cancel`}
              </button>
              <button
                className={this.props.classes.reactConfirmButtonGroupBtnWarning}
                onClick={() => {
                  if(item)
                    proceed(item)
                  else
                    proceed()
                  onClose()
                }}
              >
              {Y`Ok`}
              </button>
            </div>
          </div>
        )
      }
    })
  }

  render () {
    const { pageTexts: unfilteredPageTexts, pageTextActions, classes } = this.props

    const pageTexts = this.filterTexts(unfilteredPageTexts)

    return (
      <Paper>
        <TableToolbar store={pageTexts} storeActions={pageTextActions} title={Y`Page texts`} />
        <div style={{ paddingLeft: 24, paddingRight: 24 }}>
          <CountriesDropdown
            value={pageTexts.filter.country}
            handleChange={this.handleLanguageFilterChange}
            alwaysShowDefaultOption
          />
        </div>
        <div className={classes.tableWrapper}>
          <Table className={'striped'}>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>
                  <TableSortLabel
                    active={pageTexts.sort.orderBy === 'pageName'}
                    direction={pageTexts.sort.direction}
                    onClick={this.handleSortChange('pageName')}
                  >
                    {Y`Page name`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={pageTexts.sort.orderBy === 'title'}
                    direction={pageTexts.sort.direction}
                    onClick={this.handleSortChange('title')}
                  >
                    {Y`Title`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={pageTexts.sort.orderBy === 'country'}
                    direction={pageTexts.sort.direction}
                    onClick={this.handleSortChange('country')}
                  >
                    {Y`Country`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={pageTexts.sort.orderBy === 'language'}
                    direction={pageTexts.sort.direction}
                    onClick={this.handleSortChange('language')}
                  >
                    {Y`Language`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={pageTexts.sort.orderBy === 'modified'}
                    direction={pageTexts.sort.direction}
                    onClick={this.handleSortChange('modified')}
                  >
                    {Y`Last updated`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={pageTexts.sort.orderBy === 'modifiedBy'}
                    direction={pageTexts.sort.direction}
                    onClick={this.handleSortChange('modifiedBy')}
                  >
                    {Y`Last updated by`}
                  </TableSortLabel>
                </TableCell>
                <TableCell padding='checkbox'>
                  <Checkbox
                    checked={pageTexts.allSelected}
                    onChange={() => this.handleCheckAll()}
                    classes={{ checked: classes.checked }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pageTexts.loading
                ? <SkeletonTable rows={15} cols={8} />
                : pageTexts.sort.direction === 'desc'
                    ? pageTexts.items
                        .sort((a, b) => (b[pageTexts.sort.orderBy] <= a[pageTexts.sort.orderBy] ? -1 : 1))
                        .slice(
                          pageTexts.page * pageTexts.rowsPerPage,
                          pageTexts.page * pageTexts.rowsPerPage + pageTexts.rowsPerPage
                        )
                        .map(pageText => this.renderPageText(pageText))
                    : pageTexts.items
                        .sort((a, b) => (a[pageTexts.sort.orderBy] <= b[pageTexts.sort.orderBy] ? -1 : 1))
                        .slice(
                          pageTexts.page * pageTexts.rowsPerPage,
                          pageTexts.page * pageTexts.rowsPerPage + pageTexts.rowsPerPage
                        )
                        .map(pageText => this.renderPageText(pageText))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={pageTexts.itemCount}
                  rowsPerPage={pageTexts.rowsPerPage}
                  page={pageTexts.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Paper>
    )
  }

  renderPageText (pageText) {
    return (
      <TableRow key={pageText.id} role='checkbox' aria-checked={pageText.checked}>
        <TableCell>
          <IconButton title={Y`Edit page text`} onClick={() => this.props.pageTextActions.setActive(pageText)}>
            <EditIcon />
          </IconButton>
        </TableCell>
        <TableCell>{pageText.pageName}</TableCell>
        <TableCell>{pageText.title} </TableCell>
        <TableCell>{Y`${pageText.country}`}</TableCell>
        <TableCell>{Y`${pageText.language}`}</TableCell>
        <TableCell>
          {pageText.modified
            ? Moment.utc(pageText.modified).local().format('YYYY-MM-DD HH:mm:ss')
            : Moment.utc(pageText.created).local().format('YYYY-MM-DD HH:mm:ss')}
        </TableCell>
        <TableCell>
          {pageText.modifiedBy ? pageText.modifiedBy : pageText.createdBy}
        </TableCell>
        <TableCell padding='checkbox'>
          <Checkbox
            checked={pageText.checked}
            onChange={() => this.handleCheck(pageText)}
            classes={{ checked: this.props.classes.checked }}
          />
        </TableCell>
      </TableRow>
    )
  }

  handleCheckAll = checked => {
    if(this.props.pageTexts.selectedItems.length === 0)
      this.confirmDialog(Y`You're about to select multiple pages for deletion! Are you really sure you want to do this? After deletion, there's no going back. Note that you will still have to press the delete button.`,
      () => {this.props.pageTextActions.toggleAll(this.props.pageTexts.allSelected)},
      () => {}
      )
    else
      this.props.pageTextActions.toggleAll(this.props.pageTexts.allSelected)
  }

  handleCheck = item => {
    if(!item.checked)
      this.confirmDialog(Y`Caution! You're about to select a text for deletion. Are you really sure? You will still need to press the delete button.`,
      this.props.pageTextActions.selectItem,
      () => {},
      item 
      )
    else  
       item.checked ? this.props.pageTextActions.unselectItem(item) : this.props.pageTextActions.selectItem(item)
  }

  handleSortChange = value => event => {
    this.props.pageTextActions.setSort(value)
  }

  handleChangePage = (event, page) => {
    this.props.pageTextActions.setPage(page)
  }

  handleChangeRowsPerPage = event => {
    this.props.pageTextActions.setRowsPerPage(event.target.value)
  }

  handleFilterChange = filterType => e => {
    let filter = { ...this.props.users.filter }
    filter[filterType] = e.target.value
    this.props.pageTextActions.setFilter(filterType, e.target.value)
  }
}

PageTextsTable = connect(mapStateToProps, mapDispatchToProps)(PageTextsTable)
export default withStyles(Styles)(PageTextsTable)



// WEBPACK FOOTER //
// ./src/pages/page-texts/containers/page-texts-table.js